var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("article", { staticClass: "nti-product-tile" }, [
    _c("a", { attrs: { href: _vm.cardData.url } }, [
      _c("section", { staticClass: "nti-product-tile__image-wrapper" }, [
        _c("div", {
          staticClass: "nti-product-tile__image-container",
          style: { backgroundImage: `url(${_vm.cardData.imageUrl})` },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nti-product-tile__image-wrapper__label-container",
            class: _vm.evalCardProductType,
          },
          [
            _vm.isCourse && _vm.logoPath
              ? _c(
                  "div",
                  { staticClass: "nti-product-tile__image-container__logo" },
                  [
                    _c("img", {
                      attrs: { src: _vm.logoPath, alt: "Course logo" },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "nti-product-tile__image-wrapper__label-container__label",
                class: {
                  "nti-product-tile__image-wrapper__label-container--Course-with-image":
                    _vm.logoPath && _vm.isCourse,
                },
              },
              [_vm._v(_vm._s(_vm.productTypeDisplayName))]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "nti-product-tile__info-wrapper" }, [
        _c("h2", { staticClass: "nti-product-tile__info-container__title" }, [
          _vm._v(_vm._s(_vm.cardData.displayName)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nti-product-tile__info-container__price__wrapper" },
          [
            _c("span", { staticClass: "nti-product-tile__info-label" }, [
              _vm._v(_vm._s(_vm.verifyLabel("fromLabel"))),
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "nti-product-tile__info-container__price",
                class: {
                  "nti-product-tile__info-container__price--old":
                    _vm.discountedProduct,
                },
              },
              [_vm._v(_vm._s(_vm.formattedPrice))]
            ),
            _vm._v(" "),
            _vm.discountedProduct
              ? _c(
                  "p",
                  {
                    staticClass:
                      "nti-product-tile__info-container__price nti-product-tile__info-container__price--discount",
                  },
                  [_vm._v(_vm._s(_vm.formattedDiscountedPrice))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "nti-product-tile__info-label nti-product-tile__info-label--bottom",
              },
              [_vm._v(_vm._s(_vm.verifyLabel("exVat")))]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "nti-product-tile__button-container" }, [
        _c("button", { staticClass: "nti-button nti-button--no-border" }, [
          _vm._v(_vm._s(`${_vm.productTypeSelectLabel}`)),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }